import { createFileRoute } from "@tanstack/react-router";
import LandingPage from "../components/LandingPage";
import { useSeo } from "@/lib/seo";

function HomeRoute() {
  useSeo({
    title: "GreenTrack: Track every day. Earn your citizenship.",
    description:
      "Track your physical presence days toward U.S. naturalization. Built on 8 USC \u00a71427. AI-powered, 5 languages.",
    path: "/",
  });
  return <LandingPage />;
}

export const Route = createFileRoute("/")({
  component: HomeRoute,
});
